export const postalCodeRegex = /^[0-9]{8}$/